/**
 * @描述：对于文章的 “点赞”、“收藏”及查阅次数的操作指令
 * @作者: 张俊
 * @创建时间: 2020-05-08 15:46:10
 */
import ajaxHelperInstance from "@/lib/ajaxhelper";

let articleOperation = {
    giveLike: {
        bind(el, binding, vnode) {
            let clickHandler = (e) => {
                // 这里判断点击的元素是否是本身，不是本身，则返回
                if (!el.contains(e.target)) {
                    return false;
                }
                let {name, value} = binding;
                let {objectid} = el.dataset;
                // 判断指令中是否绑定了函数
                if (value && objectid && name === 'give-like') {
                    //objectId:点赞、收藏对象ID，文章为文章ID，回答为回答ID
                    //objectType:1: 知识库收藏; 2: 文档点赞; 3: 回答点赞; 4: 提问收藏
                    let param = {
                        objectId: objectid,
                        objectType: value
                    }
                    ajaxHelperInstance.get('/web/user/oper', param).then((res) => {
                        let {status, data} = res;
                        let {errno} = data;
                        if (status === 200 && errno === 0) {
                            alert('点赞成功');
                        }
                    });
                }
            };

            // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
            el.__vueClickOutside__ = clickHandler;
            document.addEventListener('click', clickHandler);
        },
        unbind(el, binding) {
            // 解除事件监听
            document.removeEventListener('click', el.__vueClickOutside__);
            delete el.__vueClickOutside__;
        }
    }
};

export default articleOperation;
